// src/pages/CompletePage.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/CompletePage.css";

const CompletePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = location.state || {};

  return (
    <div className="complete-page">
      <div className="confirmation-box">
        <div className="icon-check">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#4CAF50"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" stroke="#4CAF50" fill="#E8F5E9" />
            <path d="M9 12l2 2l4 -4" />
          </svg>
        </div>

        <h2>Zamówienie złożone pomyślnie!</h2>

        {orderId ? (
          <p style={{ maxWidth: 360, lineHeight: 1.5 }}>
            Otrzymasz e-mail z potwierdzeniem, gdy restauracja zaakceptuje Twoje zamówienie.
            W wiadomości znajdziesz link do śledzenia statusu zamówienia.
          </p>
        ) : (
          <p>Twoje zamówienie zostało zarejestrowane.</p>
        )}

        <button
          className="back-home-btn"
          onClick={() => navigate("/")}
          style={{
            marginTop: "20px",
            padding: "10px 18px",
            borderRadius: "10px",
            border: "none",
            background: "#00a082",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Wróć do strony głównej
        </button>
      </div>
    </div>
  );
};

export default CompletePage;
